import {
  OxExclusionLabel,
  OxExclusionTypeLabel,
} from '@oxappsec/exclusion-service';
import { IconType } from 'ox-common-types';
import {
  MdOutlineDoNotDisturbOff,
  MdOutlineKeyOff,
  MdOutlineRemoveCircle as PlaylistRemoveIcon,
} from 'react-icons/md';
import { IconBrowserOff, IconCashOff } from '@tabler/icons-react';
import { ReactComponent as PolicyXIcon } from '../../assets/icons/policyX.svg';
import { ExclusionsFilters } from '../types/exclusion-types';

export const ExclusionsActionIconMap = new Map<OxExclusionTypeLabel, IconType>([
  [OxExclusionTypeLabel.specificIssue, MdOutlineDoNotDisturbOff],
  [OxExclusionTypeLabel.detectionRuleInAllApps, IconCashOff as IconType],
  [OxExclusionTypeLabel.detectionRuleInApp, IconBrowserOff as IconType],
  [OxExclusionTypeLabel.appIrrelevance, PlaylistRemoveIcon],
  [OxExclusionTypeLabel.disablePolicy, PolicyXIcon],
  [OxExclusionTypeLabel.secretInAllApps, MdOutlineKeyOff],
]);

export enum ExclusionLabel {
  ExcludeThisIssueOnly = 'Exclude this issue only',
  ExcludeTheSecretsInAllApplications = 'Exclude the secret(s) in all applications',
  ExcludeTheDetectionRuleInAllApplications = 'Exclude the detection rule in all applications',
  ExcludeTheDetectionRuleInThisApplication = 'Exclude the detection rule in this application',
}

export const getExclusionTypeFromLabel = (label: OxExclusionLabel) => {
  switch (label) {
    case 'Exclude this issue only':
      return OxExclusionTypeLabel.specificIssue;
    case 'Exclude the secret(s) in all applications':
      return OxExclusionTypeLabel.secretInAllApps;
    case 'Exclude the detection rule in all applications':
      return OxExclusionTypeLabel.detectionRuleInAllApps;
    case 'Exclude the detection rule in this application':
      return OxExclusionTypeLabel.detectionRuleInApp;
    default:
      return OxExclusionTypeLabel.specificIssue;
  }
};

export const snackBarSpplitingName = (input: string) => {
  if (input.length > window.innerWidth / 10) {
    return input.slice(0, window.innerWidth / 10) + '...';
  }
  return input;
};

export const getFilteredFilters = (filterExclusionsBy?: ExclusionsFilters) => {
  return (
    filterExclusionsBy &&
    Object.keys(filterExclusionsBy).reduce((acc: ExclusionsFilters, key) => {
      const filterKey = key as keyof ExclusionsFilters;
      const filterValue = filterExclusionsBy[filterKey] as string[] | undefined;
      if (filterValue && filterValue.length > 0) {
        acc[filterKey] = filterValue;
      }
      return acc;
    }, {})
  );
};
